import { render, staticRenderFns } from "./newscenterdetail.vue?vue&type=template&id=5e6120a1&scoped=true&"
import script from "./newscenterdetail.vue?vue&type=script&lang=js&"
export * from "./newscenterdetail.vue?vue&type=script&lang=js&"
import style0 from "./newscenterdetail.vue?vue&type=style&index=0&id=5e6120a1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6120a1",
  null
  
)

export default component.exports